import ViewComfyIcon from "@material-ui/icons/ViewComfy";
import PropertyTypeList from "./PropertyTypeList";

export default {
  list: PropertyTypeList,
  icon: ViewComfyIcon,
};
